import React from 'react'

function Tpl() {
  return (
    <div>Tpl</div>
  )
}

export default Tpl